import { Typography } from "@mui/material";
import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";
import { RevenueOverview } from "@arelia-types/earnings";
import { ReactElement } from "react";
import { EarningsChange } from "@arelia-components/ui-atoms/EarningsChange";
import { formatDate } from "@arelia-utils/helpers/dates";
import { formatCurrency } from "@arelia-utils/helpers/formatCurrency";

type Props = {
  data: RevenueOverview;
  loading: boolean;
  error: boolean;
  detailsPagePath?: string;
  widgetId: string;
  title: string;
  headerComponent?: ReactElement
  extraActions?: ReactElement;
  unconnected?: boolean;
  selectedPeriod?: string;
};

export default function RoyaltiesPresenter({ data, loading, error, detailsPagePath, widgetId, title, headerComponent, extraActions, unconnected, selectedPeriod }: Props) {
  return (
    <WidgetCard
      widgetId={widgetId}
      title={title}
      loading={loading}
      error={error}
      unconnected={unconnected}
      footerText={`Last updated: ${formatDate(data.updatedAt, "P")}`}
      headerComponent={headerComponent}
      navigateLink={detailsPagePath}
      extraActions={extraActions}
    >
      <Typography variant="h2">{formatCurrency(data.total)} Total</Typography>
      <EarningsChange data={data} selectedPeriod={selectedPeriod} />
    </WidgetCard>
  );
}
